import React from 'react';

export interface DelayNodeProps {
  /** Formatted delay text (e.g. "Wait 5 minutes") */
  formattedDelay: string;
  /** Optional formatted conditions text for delay branches */
  formattedConditions?: string;
  /** Whether the node has conditions to show */
  hasConditions?: boolean;
}

const DelayNode = ({
  formattedDelay,
  formattedConditions = '',
  hasConditions = false,
}: DelayNodeProps) => {
  const hasContent = formattedDelay || (hasConditions && formattedConditions);

  return (
    <div className="p-4 space-y-1">
      {formattedDelay && (
        <p className="text-xs text-muted-foreground font-medium">
          {formattedDelay}
        </p>
      )}
      {hasConditions && formattedConditions && (
        <p className="text-xs text-muted-foreground line-clamp-2">
          {formattedConditions}
        </p>
      )}
      {!hasContent && (
        <p className="text-xs text-muted-foreground italic">
          No delay configured
        </p>
      )}
    </div>
  );
};

export default DelayNode;
